import React, { useEffect, useState } from 'react';
import '../../styles/career/main.css';
import { getAllCareerInfo } from '../../Services/AllAPIs';
import LoadingSpinner from '../LoadingSpinner';

const Main = () => {

    const [loader, setLoader] = useState(true);
    const [career, setCareer] = useState([]);
    const [error, setError] = useState(null);

    // Fetch career data
    const getCareer = () => {
        getAllCareerInfo()
            .then((res) => {
                // console.log('career--->', res.data.news);
                const careerData = Object.values(res.data.news || {});
                setCareer(careerData);
                setLoader(false);
            })
            .catch((error) => {
                console.error(error);
                setError("An error occurred while fetching career data.");
                setLoader(false);
            });
    };

    useEffect(() => {
        getCareer();
    }, []);


    // Function to format date as DD/MM/YYYY
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };

    return (
        <div id='careerMain'>
            <div className="career-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">

                        {loader && <LoadingSpinner />}
                        {error && <div className="error">{error}</div>}

                        <div className="onl-portal-lnk">
                            <a href="https://forms.ccsuforms.in/Recruitment/" target="_blank" rel="noreferrer" >
                                <span>
                                    <i className="fas fa-external-link-alt mr-1" />
                                </span>{" "}
                                Online Portal for Contractual/Permanent Recruitment of
                                Teaching/Faculty Assistant/Faculty in Different Departments in
                                University Campus
                            </a>
                        </div>

                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Employment/Vacancies</h2>

                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Title</th>
                                                <th>Posted Date</th>
                                                <th>Download</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {career.length > 0 ? (
                                                career.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.title}</td>
                                                        <td>{formatDate(item.created_at)}</td>
                                                        <td>
                                                            <a
                                                                href={item.url}
                                                                className="btn btn-primary btn-download"
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                            >
                                                                Download
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3">No career data available.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Main;
